<header class="form__header">
  <h4 class="form__title">{{ config.form.title }}</h4>
  @if (config.form.description) {
    <p class="form__description">
      {{ config.form.description }}
    </p>
  }
</header>

@if (!isRegistrationComplete) {
  <form-group
    class="form__controls"
    [form]="form"
    [configs]="config.form.controls"
    direction="filter"
  >
  </form-group>
  <footer class="form__footer">
    <a class="form__link" [routerLink]="'/auth/login'">
      {{ config.login_link_label }}
    </a>
    <zip-button
      [config]="config.submit"
      (zipButtonClicked)="isRegistrationComplete = true"
    >
    </zip-button>
  </footer>
} @else {
  <section class="complete">
    <h6 class="form__title">{{ config.complete.title }}</h6>
    <p class="form__description">
      {{ config.complete.description }}
      <span class="complete__description__link" (click)="resendEmail()"
        >resend the email</span
      >.
    </p>
    @if (emailVerification) {
      <message-banner
        class="complete__verification"
        [config]="emailVerification"
      >
      </message-banner>
    }
  </section>
}
